import React from "react";
import {
  Typography,
  TextField,
  Box,
  Button,
  FormControlLabel,
  Checkbox,
  IconButton,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { AddBox } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import InfoPopover from "../../../../utils/informationButton";

const SwitchResponseComponent = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        <Typography variant="h6" className={props.classes.responseTitle}>
          {t("newEnigma.responses")}
        </Typography>
        <InfoPopover
          title={t("newEnigma.Réponse_on_off")}
          text={t("newEnigma.enter_label")}
          src="/images/reponse-switch.webp"
        />
      </Box>

      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "row",
        }}
      >
        <Button
          variant="contained"
          color="secondary"
          className={props.classes.uploadFile}
          startIcon={<AddBox />}
          component="label"
          style={{
            marginBottom: "16px",
          }}
          onClick={props.addSwitch}
        >
          {t("newEnigma.add_switch")}
        </Button>
      </Box>
      {props.state.formDatas?.switchLabels?.map((label, index) => {
        let switchId = `switch-label-${index.toString()}`;
        let switchLabel = `Label ${index} (${t("newEnigma.optionnel")})`;

        return (
          <div
            key={
              props.state.enigmaLoaded
                ? `${switchId}SwitchNotLoaded`
                : `${switchId}SwitchenigmaLoaded`
            }
          >
            <Box
              direction="row"
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                flexDirection: "row",
              }}
            >
              <TextField
                id={switchId}
                label={switchLabel}
                variant="outlined"
                size="small"
                className={props.classes.textfieldPropositions}
                onChange={(event) =>
                  props.handleSwitchLabelChange(event, index)
                }
                type="text"
                value={label}
                key={
                  props.state.enigmaLoaded
                    ? `${switchId}NotLoaded`
                    : `${switchId}enigmaLoaded`
                }
              />
              <FormControlLabel
                key={
                  props.state.enigmaLoaded
                    ? `${switchId}ControlNotLoaded`
                    : `${switchId}ControlenigmaLoaded`
                }
                control={
                  <Checkbox
                    key={
                      props.state.enigmaLoaded
                        ? `${switchId}CheckboxNotLoaded`
                        : `${switchId}CheckboxenigmaLoaded`
                    }
                    checked={
                      props.state.formDatas.switchValues
                        ? props.state.formDatas.switchValues.length > index
                          ? props.state.formDatas.switchValues[index]
                          : ""
                        : ""
                    }
                    onChange={(event) =>
                      props.handleSwitchValueChange(event, index)
                    }
                    color="primary"
                  />
                }
                label="ON"
              />
              {index !== 0 ? (
                <IconButton
                  key={
                    props.state.enigmaLoaded
                      ? `${switchId}RemoveBtnNotLoaded`
                      : `${switchId}RemoveBtnControlenigmaLoaded`
                  }
                  edge="end"
                  aria-label="delete"
                  onClick={(e) => props.removeSwitch(e, index)}
                >
                  <DeleteIcon style={{ color: "red" }} />
                </IconButton>
              ) : (
                <Box style={{ width: "35px" }} />
              )}
            </Box>
          </div>
        );
      })}
    </>
  );
};

export default SwitchResponseComponent;
